// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"9248f3ec","404":"8a0edf25","498":"c0cdfe7f","513":"ce943078","787":"5a96452d"}[chunkId] + ".chunk.js";
};